import { createContentHook } from './createContentHook';
import type { SalesAndResourcesContactPointsContent } from '../types/SalesAndResourcesContactPointsContent';

export const useSalesAndResourcesContactPointsContent =
    createContentHook<SalesAndResourcesContactPointsContent>('/SalesAndResources/ContactPoints');
